<template>
  <BaseModal :config="InputControlModalLabel" @ResetFields="resetFields" @SaveChanges="saveChanges">
    <div style="width:100%; max-height:500px;overflow-y:auto; overflow-x:hidden;">
      <form ref="refInputControlForm" id="InputControlForm" action>
          <div id="pageErrors"
				class="alert alert-danger" v-if="pageErrors.length>0">
				<p>
				<b>Please correct the following error(s):</b>
				    <ul>
						<li v-for="error in pageErrors"
							:key="error">{{ error }}</li>
						</ul>
					</p>
			</div>
        <div class="form-row">
          <div class="form-group col-md-6">
            <label class="required-label">Field</label>
              <div id="kendo-select">
                <kendo-dropdownlist v-model="InputControlInfo.Field"
                            :data-source="FieldOptions"
                            :option-label="'Select Field'"
                            >
                </kendo-dropdownlist>   
              </div>
          </div>
          <div class="form-group col-md-6">
            <label class="required-label">Option</label>
            <div id="kendo-select">
              <input
                type="text"
                v-model="InputControlInfo.Option"
                class="form-control"
                placeholder="Option"
                name="Option"
              >
            </div>
          </div>
        </div>
      </form>
    </div>
  </BaseModal>
</template>

<script>
import BaseModal from "@/components/base/BaseModal.vue";
import funcUtil from "@/services/funcUtil.js";
import BaseModelInputControl from "@/models/BaseModelInputControl.js";
import BaseModelProgram from "@/models/BaseModelProgram.js";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "InputControlForm",
  components: {
    BaseModal
  },
  mixins: [funcUtil],
  computed: {
    ...mapGetters("getModule", ["withFilter","getLocalInputControls"]),
  },
  props: {
    InputControlInfo: {},
    InputControlModalLabel: {}
  },
  data: function() {
    return {
      GridConfig: BaseModelInputControl,
      BaseModelProgram: BaseModelProgram,
      BaseModelInputControl:BaseModelInputControl,
      pageErrors:[],
      FieldOptions:[]
    };
  },
  methods: {
    ...mapActions("postModule", ["UpdateItems", "CreateItems"]),
    resetFields(e) {
        this.pageErrors = [];
    },
    saveChanges(e) {
      let self = this;
      if(self.Validate()){
        if (this.InputControlModalLabel.modalAddorEdit == "add") {
            let addFormValues = self.InputControlInfo;
            let createItem = {
            list: self.GridConfig,
            payload: addFormValues
            };
            //let loader = self.$loading.show();
            self._APICrudPopup("APICrudpopup");
            self.CreateItems(createItem).then(res => {
               $("#InputControlGrid").data().kendoGrid.dataSource.read();
               self._AlertPopup("Data Saved Successfully!", "success");
            }).catch(error=>{
              self._AlertPopup("Some Error Occurred!","info");
            }).finally(() => {
                //loader.hide();
            });
        } else {
            let editFormValues = self.InputControlInfo;
            let updateItem = {
            list: self.GridConfig,
            payload: editFormValues
            };
           // let loader = self.$loading.show();
            self._APICrudPopup("APICrudpopup");
            self.UpdateItems(updateItem).then(res => {
                $("#InputControlGrid").data().kendoGrid.dataSource.read();
                self._AlertPopup("Data Updated Successfully!", "success");
            }).catch(error=>{
              self._AlertPopup("Some Error Occurred!","info");
            }).finally(()=>{
                //loader.hide();
            })
        }
            $("#BaseModal").modal("toggle");
            self.resetFields();
        }
    },
    Validate() {
      const self = this;
      self.pageErrors = [];
      let form = self.InputControlInfo;
      console.log(form);
      //Form Validations
      if (form.Field == "" ) {
        self.pageErrors.push("Field is required");
      }
      //InputControl Type
      if (form.Option == "") {
        self.pageErrors.push("Option Type is required");
      }
      if(!form.Field == "" && !form.Option == "")
      {
         self.CheckIfAlreadyexists();
      }
      if (self._validateSpecialCharacter(form.Option,"singleline")) {
          self.pageErrors.push(`Option cannot have ${this.SingleLineSpecialChars}  Characters`);
      }
      
      return self.pageErrors.length > 0 ? false : true;
    },
    CheckIfAlreadyexists()
    {
      const self=this;
      let form = self.InputControlInfo;
      let InputControllist=self.withFilter(BaseModelInputControl.list);
      var result =_.filter(InputControllist, function(InputControl) {
      return InputControl.Field == self.InputControlInfo.Field && InputControl.Option == self.InputControlInfo.Option ;
      });
      if(result.length > 0)
      { 
        self.pageErrors.push("Values entered for Field and Option already exists.");
      }
    },
    getUniqueFields()
    {
      const self=this;
      let InputControllist=self.withFilter(BaseModelInputControl.list);
      self.FieldOptions=_.sortBy(_.uniq(_.map(InputControllist, 'Field')));
    }
  },
  mounted(){
    this.getUniqueFields();
    this.resetFields();
    //For Displaying List on Focus
    
  }
};
</script>

<style>
</style>
